<template>
  <div
    ref="search"
    class="custom-search-input"
    :class="{'show-search-field' : showSearchField}"
  >
    <a-input
      v-model="internalSearchValue"
      ref="search-input"
      :placeholder="placeholder"
      :size="size"
      :disabled="disabled"
      :loading="loading"
      @change="onSearch"
    >
      <span slot="prefix" class="custom-search-input__search-icon" @click="toggleShow">
        <a-icon type="search" />
      </span>
      <a-icon
        v-if="showSearchField && internalSearchValue.length"
        slot="suffix"
        type="close-circle"
        theme="filled"
        style="color: #9e9e9e; width: 12px;"
        @click.stop="clearSearchValue"
      />
    </a-input>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    size: {
      type: String,
      default: 'large',
    },
    placeholder: {
      type: String,
      default: 'Input search text',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    internalSearchValue: '',
    showSearchField: false,
    searchTimeout: null,
  }),
  watch: {
    value(newVal) {
      this.internalSearchValue = newVal || ''
      if (this.internalSearchValue?.length && !this.showSearchField) {
        this.toggleShow()
      }
    },
  },
  methods: {
    clickHandler({ target }) {
      if (!this.showSearchField || this.$refs['search'].contains(target)) {
        return
      }
      this.toggleShow()
    },
    keyHandler({ keyCode }) {
      const inputEl = this.$refs['search-input']?.$el?.querySelector('input')
      if (document.activeElement !== inputEl || !this.showSearchField) {
        return
      }

      if (keyCode === 27) {
        this.toggleShow()
        return
      }

      if (keyCode === 13 && this.searchTimeout) {
        const searchValue = inputEl.value
        this.$emit('search', searchValue)
        clearTimeout(this.searchTimeout)
        this.focusInput()
      }
    },
    toggleShow() {
      if (this.internalSearchValue?.length && this.showSearchField) {
        return
      }
      this.showSearchField = !this.showSearchField
    },
    onSearch(event) {
      const value = event.target.value

      clearTimeout(this.searchTimeout)

      this.searchTimeout = setTimeout(() => {
        this.$emit('search', value)
        clearTimeout(this.searchTimeout)
        this.focusInput()
      }, 1000)
    },
    focusInput() {
      setTimeout(() => {
        this.$refs['search-input'].focus()
      }, 300)
    },
    clearSearchValue() {
      this.$emit('search', '')
      this.focusInput()
    },
  },
  mounted() {
    if (this.value !== '' || this.value !== undefined || this.value !== null) {
      this.internalSearchValue = this.value
      this.toggleShow()
    }
    document.addEventListener('click', this.clickHandler)
    document.addEventListener('keydown', this.keyHandler)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickHandler)
    document.removeEventListener('keydown', this.keyHandler)
  },
}
</script>

<style lang="scss">
.custom-search-input {
  &__search-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    margin-left: 2px;
    & i > svg {
      width: 18px;
      height: 18px;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .ant-input-prefix {
    left: 0 !important;
  }
  .ant-input {
    width: 0 !important;
    padding-left: 40px !important;
  }
  input {
    padding: 6px 0 !important;
  }
}
.show-search-field {
  .ant-input {
    width: 200px !important;
    padding-left: 40px !important;
  }
  input {
    padding: 6px 11px !important;
  }
}
</style>
